<loading-indicator [show]="!formReady || saving"></loading-indicator>

<div [formGroup]="formData" class="generatedHTMLWindow generatedHTMLForm angularForm" *ngIf="formReady">
  <div class="formHeader">
    <span class="navigateBtn navigate-left" (click)="previousTenant()" *ngIf="showPrevBtn && currentOid > 0">
      <svg-icon title="{{'navigation.previous' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
    <span class="headerTitle">{{'tenant.tenantDetails' | translate}}</span>
    <span class="navigateBtn navigate-right" (click)="nextTenant()" *ngIf="showNextBtn && currentOid > 0">
      <svg-icon title="{{'navigation.next' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
  </div>
  <div class="generatedHTMLRoot">
    <div class="mainSection">
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'tenant.tenantInformation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.TenantFileRefNo' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="TenantFileRefNo" kendoTextBox id="form-TenantFileRefNo" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.LeaseName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="LeaseName" kendoTextBox id="form-LeaseName" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.LeaseType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="LeaseType" kendoTextBox id="form-LeaseType" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.UnitDescription' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="UnitDescription" kendoTextBox id="form-UnitDescription" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.Sector' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Sector" kendoTextBox id="form-Sector" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.Region' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Region" kendoTextBox id="form-Region" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PrimaryUse' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PrimaryUse" kendoTextBox id="form-PrimaryUse" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.Status' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Status" kendoTextBox id="form-Status" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.TenantUse' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="TenantUse" kendoTextBox id="form-TenantUse" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.LeaseStart' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="LeaseStart" id="form-LeaseStart" [format]="dateFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.LeaseExpiry' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="LeaseExpiry" id="form-LeaseExpiry" [format]="dateFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.AreaSqft' | translate }} | {{formData.value.UnitOfLengthSymbol}}²</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="AreaSqft" format="n2" [spinners]="false" id="form-AreaSqft"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.Covenant' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Covenant" kendoTextBox id="form-Covenant" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.ValuationMethod' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ValuationMethod" kendoTextBox id="form-ValuationMethod" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.NextReview' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="NextReview" id="form-NextReview" [format]="dateFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.EarliestTermination' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="EarliestTermination" id="form-EarliestTermination" [format]="dateFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PeriodToTermination' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PeriodToTermination" format="n2" [spinners]="false" id="form-PeriodToTermination"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.BreakType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="BreakType" kendoTextBox id="form-BreakType" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.EffectiveBreak' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="EffectiveBreak" id="form-EffectiveBreak" [format]="dateFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PeriodToBreak' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PeriodToBreak" format="n2" [spinners]="false" id="form-PeriodToBreak"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PeriodToExpiry' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PeriodToExpiry" format="n2" [spinners]="false" id="form-PeriodToExpiry"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.VoidExpiryByBreak' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="VoidExpiryByBreak" format="n2" [spinners]="false" id="form-VoidExpiryByBreak"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.RentFreePeriod' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="RentFreePeriod" format="n2" [spinners]="false" id="form-RentFreePeriod"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.GroundRent' | translate }} | {{formData.value.CurrencySymbol}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="GroundRent" format="n2" [spinners]="false" id="form-GroundRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.ContractedRent' | translate }} | {{formData.value.CurrencySymbol}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ContractedRent" format="n2" [spinners]="false" id="form-ContractedRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.DeemedRent' | translate }} | {{formData.value.CurrencySymbol}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="DeemedRent" format="n2" [spinners]="false" id="form-DeemedRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.GrossValue' | translate }} | {{formData.value.CurrencySymbol}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="GrossValue" format="n2" [spinners]="false" id="form-GrossValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.RentalValue' | translate }} | {{formData.value.CurrencySymbol}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="RentalValue" format="n2" [spinners]="false" id="form-RentalValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.VacantPeriod' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="VacantPeriod" format="n2" [spinners]="false" id="form-VacantPeriod"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.ErvRatePerSqft' | translate }} | {{formData.value.UnitOfLengthSymbol}}²</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvRatePerSqft" format="n2" [spinners]="false" id="form-ErvRatePerSqft"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.RentRatePerSqft' | translate }} | {{formData.value.UnitOfLengthSymbol}}²</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="RentRatePerSqft" format="n2" [spinners]="false" id="form-RentRatePerSqft"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.ErvVacancyLoss' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvVacancyLoss" format="n2" [spinners]="false" id="form-ErvVacancyLoss"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.Froth' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="Froth" format="n2" [spinners]="false" id="form-Froth"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PercentErv' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErv" format="n2" [spinners]="false" id="form-PercentErv"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PercentRent' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentRent" format="n2" [spinners]="false" id="form-PercentRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PercentErvVacancyLoss' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErvVacancyLoss" format="n2" [spinners]="false" id="form-PercentErvVacancyLoss"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PercentFroth' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentFroth" format="n2" [spinners]="false" id="form-PercentFroth"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.ErvUplift' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvUplift" format="n2" [spinners]="false" id="form-ErvUplift"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.ErvVoidLoss' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvVoidLoss" format="n2" [spinners]="false" id="form-ErvVoidLoss"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          &nbsp;
        </div>
        <div>
          <div class="inlineBlockHeader">
            &nbsp;
          </div>
          <div class="sectionTitleContainer inlineBlockHeader">
            <span class="sectionTitle">{{ 'tenant.yieldInformation' | translate | uppercase}}</span>
          </div>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PercentErvUpliftPerRent' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErvUpliftPerRent" format="n2" [spinners]="false" id="form-PercentErvUpliftPerRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.PercentErvUpliftPerTotalRent' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErvUpliftPerTotalRent" format="n2" [spinners]="false" id="form-PercentErvUpliftPerTotalRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.HardcoreYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="HardcoreYield" format="n2" [spinners]="false" id="form-HardcoreYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.FrothYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="FrothYield" format="n2" [spinners]="false" id="form-FrothYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.CostDeductions' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="CostDeductions" format="n2" [spinners]="false" id="form-CostDeductions"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.CapitalisationGroup' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="CapitalisationGroup" kendoTextBox id="form-CapitalisationGroup" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.DcfExitYld' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="DcfExitYld" format="n2" [spinners]="false" id="form-DcfExitYld"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.ReversionYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ReversionYield" format="n2" [spinners]="false" id="form-ReversionYield"></kendo-numerictextbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          &nbsp;
        </div>
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'comparablesLease.systemInformation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.createdBy' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="OwnerUserDescription" kendoTextBox id="form-OwnerUserDescription" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.createdAt' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="DateCreated" id="form-DateCreated" [format]="dateTimeFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.modifiedBy' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ModifiedByUserDescription" kendoTextBox id="form-ModifiedByUserDescription" />
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'tenant.modifiedAt' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="DateModified" id="form-DateModified" [format]="dateTimeFormat" placeholder=""></kendo-datepicker>
                </div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width25percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
